<template>
  <Row :gutter="24" class="editReportPage">
    <!--患者基本信息-->
    <Col :span="4" class="pageLeft">
      <Card :bordered=false>
        <div class="patientInfo">
          <h3 class="infoTitle">影像</h3>
          <a class="imageCate" @click="openWeasis(patientInfo)">Unimed-K</a>
          <a class="imageCate" @click="openOsirix(patientInfo)">Osirix</a>
          <a @click="openFilmView(patientInfo)">WebViewer</a>
        </div>
        <div class="patientInfo">
          <div class="infoTitle">
            <h3>患者信息</h3>
            <a class="editHistory" @click="openDieaseModal">编辑病史</a>
          </div>
          <p>姓名：{{patientInfo.name}}</p>
          <p>性别：{{patientInfo.gender}}</p>
          <p>年龄：{{patientAge}}{{ageUnit|getAgeUnit}}</p>
          <p>生日：{{patientInfo.patientBirthDay}}</p>
          <p>身高：{{patientInfo.height}}<span v-if="patientInfo.height">cm</span></p>
          <p>体重：{{patientInfo.weight}}<span v-if="patientInfo.weight">Kg</span></p>
          <p>电话：{{patientInfo.mobile}}</p>
          <p>病史：{{patientInfo.medicalHistory}}</p>
          <p>备注：{{patientInfo.remark}}</p>
        </div>
        <div class="bodyNameAndAlias" v-if="patientInfo.bodyItems">
          <h3>检查部位</h3>
          <div v-for="(item, index) in patientInfo.bodyItems" :key="index">
            <p>部位名：{{item.name || ''}}</p>
            <p v-if="item.alias">别名：{{item.alias || ''}}</p>
          </div>
        </div>
        <div class="otherAction">
          <div class="leftCell" v-if="patientInfo.information">
            <h3>相关资料</h3>
            <a class="cellAction" @click="seeMessage">查看</a>
          </div>
          <div class="leftCell">
            <h3>历史检查</h3>
            <a class="cellAction" @click="watchCheckHistoy">查看</a>
          </div>
          <div class="leftCell">
            <h3>报告修改痕迹</h3>
            <a class="cellAction" @click="watchReportTrace">查看</a>
          </div>
          <div class="leftCell">
            <h3>审核不通过原因</h3>
            <a class="cellAction" @click="viewNotPass('clickView')">查看</a>
          </div>
          <div class="scanning">
            <h3>扫描技师：</h3>
            <p style="">{{patientInfo.technicianName}}</p>
            <span>
              <img src="https://webimage.tongxinyiliao.com/ris/images/images.png" style="width:16px;" @click="showImagesRecord()"/>
            </span>
          </div>
        </div>
      </Card>
    </Col>
    <!--报告 -->
    <Col :span="16" class="pageCenter">
      <div class="operateWrap">
        <div>
          <Button class="giveUp" @click="giveUpReports" v-if="10 === status && role.write" :loading="giveUpModal.giveUpBtnLoading">放弃</Button>
          <Button class="giveUp" @click="giveUpReports" v-if="30 === status && role.review" :loading="giveUpModal.giveUpBtnLoading">放弃</Button>
          <Button class="giveUp" @click="recallReport" v-if="[20,100].includes(status) && (role.loginUserId == writeDoctorId || role.loginUserId == checkDoctorId || role.superDoctor)">召回</Button>
        </div>
        <div class="btnGroup">
          <Button @click="saveReport" v-if="[10, 30].includes(status)">保存</Button>
          <Button @click="submitAudit" v-if="role.write && status===10">提交审核</Button>
          <Button @click="pass" v-if="role.review && [10,30].includes(status)">通过</Button>
          <Button @click="notPass" v-if="role.review && [30].includes(status)">不通过</Button>
          <Button @click="goBack">返回</Button>
          <Button @click="printReport" v-if="100==status">打印</Button>
          <Button v-if="hospitalFlag === '0' && [10, 30].includes(status)" @click="passAndPrintReport" :loading="passAndPrintLoading">通过并打印</Button>
        </div>
      </div>
      <div class="reportWrap">
        <ReportTemplate :type="reportTemplateType" @saveTemplate="saveTemplate"/>
      </div>
    </Col>
    <!--报告模板 -->
    <Col :span="4" class="pageRight">
      <div class="templateTitle">
        <h2>报告模板</h2>
        <div class="operate">
          <a @click="editTreeClass">{{editTitleCon}}</a>
          <a @click="addCode">新增一级分类</a>
        </div>
      </div>
      <div class="contextWrap">
        <Tree class="cateWrap" :treeData="treeData" @select="choiceTreeCode" :expandedKeys="expandedKeys">
          <template slot="custom" slot-scope="item">
            <span class="titleCol">{{item.title}}</span>
            <Icon type="edit" class="editTreeIcon" @click="editCode(item)" v-if="editFlag"/>
            <Icon type="plus-circle-o" class="editTreeIcon" @click="addNewMould(item)" v-if="editFlag"/>
            <Icon type="minus-circle-o" class="editTreeIcon" @click="removeCode(item)" v-if="editFlag"/>
          </template>
        </Tree>
      </div>
    </Col>
    <!-- 审核通过或不通过弹框 -->
    <Modal :title="auditModal.title" v-model="auditModal.openFlag" v-if="auditModal.openFlag" @ok="sureAudit" :confirmLoading="auditModal.sureBtnLoading">
      <div v-if="auditModal.showPass">
        <p>是否确认通过审核？</p>
        <p>通过审核后，报告将发送至各相关系统</p>
      </div>
      <div v-if="auditModal.showNotPass">
        <p>是否确认不通过审核？</p>
        <p>确定之后，报告将由编写医生重写</p>
        不通过原因
        <div class="notPassContent" style="margin-left: 17%; margin-top: -8%;text-align: right;">
          <span>剩余 {{700 - auditModal.notPassMsg.length}} 字</span>
          <TextArea v-model.trim="auditModal.notPassMsg" :autosize="{ minRows: 5, maxRows: 20 }"></TextArea>
        </div>
      </div>
    </Modal>
    <!-- 放弃编写弹框 -->
    <Modal title="放弃" v-model="giveUpModal.openFlag" v-if="giveUpModal.openFlag" @cancel="cancelGiveUp">
      <div slot="footer">
        <div v-if="!giveUpModal.multiple">
          <Button size="large" @click="cancelGiveUp">取消</Button>
          <Button size="large" type="primary" @click="giveUpCurrent" :loading="giveUpModal.currentBtnLoading">确认</Button>
        </div>
        <div v-if="giveUpModal.multiple">
          <Button size="large" @click="cancelGiveUp">取消</Button>
          <Button size="large" type="primary" @click="giveUpCurrent" :loading="giveUpModal.currentBtnLoading">只放弃当前报告</Button>
          <Button size="large" type="primary" @click="giveUpAll" :loading="giveUpModal.allBtnLoading">全部放弃</Button>
        </div>
      </div>
      <div v-if="!giveUpModal.multiple">
        <p>是否放弃{{giveUpModal.type}}报告？</p>
        <p>放弃后，报告将由其他医生完成{{giveUpModal.type}}</p>
      </div>
      <div v-if="giveUpModal.multiple">
        <p>该检查共有 {{giveUpModal.tableData.length}} 个处理中的报告订单，您是否全部放弃？</p>
        <p>放弃后，该报告将由其他医生完成{{giveUpModal.type}}</p>
        <Table :columns="giveUpModal.tableColumns" :dataSource="giveUpModal.tableData" bordered :pagination=false rowKey="id">
          <template slot="cate" slot-scope="text, record">
            {{record.report_category|reportType}}
          </template>
          <template slot="reportStatus" slot-scope="text, record">
            {{record.status|reportStatus}}
          </template>
        </Table>
      </div>
    </Modal>
    <!-- 新增或编辑节点 -->
    <Modal :title="changeTreeInfo.title" v-model="changeTreeInfo.modalFlag" v-if="changeTreeInfo.modalFlag" @ok="sureAddClass" :confirmLoading="sureAddClassLoading">
      <Input placeholder="请输入分类标题名称" v-model="changeTreeInfo.inputVal"/>
    </Modal>
    <!-- 修改报告模板 -->
    <Modal :title="templateTitle" v-model="showReportTemplate" v-if="showReportTemplate" @cancel="handleCancel" :footer="null" :width="682">
      <ReportTempModal :classInfo="treeData" @handleCancel="handleCancel" @deleteTemplate="deleteTemplate" :tempInfo="tempInfo" :reportId="routerParamsReportId"></ReportTempModal>
    </Modal>
    <Modal title="不通过原因" v-model="notPassWhy.showNotPassWhy">
      <div class="notPassList">
        <Table bordered :pagination="false" :dataSource="notPassWhy.notPassList" :columns="notPassWhy.columns" rowKey="review_date"></Table>
      </div>
      <div slot="footer">
        <Button type="primary" @click="cancelNotPassWhy" :loading="notPassWhy.sureBtnLoading">确定</Button>
      </div>
    </Modal>
    <!-- 召回报告 -->
    <Modal title="召回" v-model="recall.openFlag" v-if="recall.openFlag"  @cancel="recallCancel" @ok="recallAction" :confirmLoading="recall.sureBtnLoading">
      <p>是否确认报告召回？</p>
      <p>确认召回后，报告将回到”{{recall.targetAddress}}“状态</p>
    </Modal>
    <Modal title="提交审核" v-model="submitAuditModal.openFlag" v-if="submitAuditModal.openFlag" @cancel="auditCancel">
      <div v-if="!submitAuditModal.errorMsg">
        <p>是否提交审核？</p>
        <p>提交审核后，该报告将不能修改</p>
      </div>
      <div v-if="submitAuditModal.errorMsg">
        <p>报告内容逻辑错误，是否忽略并提交审核？</p>
        <p>错误原因：{{submitAuditModal.errorMsg}}</p>
      </div>
      <div slot="footer">
        <Button size="large" @click="auditCancel">{{submitAuditModal.errorMsg? '返回': '取消'}}</Button>
        <Button type="primary" size="large" @click="submitAudit('action')" :loading="submitAuditModal.btnLoading">{{submitAuditModal.errorMsg? '提交审核': '确定'}}</Button>
      </div>
    </Modal>
    <!-- 编辑病史 -->
    <Modal title="编辑病史" v-model="dieaseHistory.openFlag" v-if="dieaseHistory.openFlag" @cancel="closeDieaseHistory" class="editDieaseHistory">
      <div class="mainContent">
        <div class="contentWrap">
          <span class="title">既往病史</span>
          <span>剩余{{700-dieaseHistory.dieaseContent.length}}字</span>
          <TextArea v-model="dieaseHistory.dieaseContent" :rows="10" maxlength="700"></TextArea>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="closeDieaseHistory">取消</Button>
        <Button type="primary" size="large" @click="saveDieaseHistoy">确认</Button>
      </div>
    </Modal>
    <!-- 相关资料预览 -->
    <Modal title="相关资料" v-model="relevantInfomation.openFlag" v-if="relevantInfomation.openFlag" class="callNumPageRelevant" :width="670">
      <viewer :images="relevantInfomation.fileList">
        <img v-for="src in relevantInfomation.fileList" :src="src" :key="src" width="200" style="margin-right: 10px; margin-bottom: 10px; cursor:pointer;">
      </viewer>
      <div slot="footer">
        <Button size="large" @click="closeRelevantModal">返回</Button>
      </div>
    </Modal>
    <!-- 影像操作记录 -->
    <Modal v-model="imagesRecordFlag" title="影像操作记录" :width="960" :footer="null" :forceRender="false">
      <imagesRecord v-if="imagesRecordFlag" @closeImagesRecord="closeImagesRecord" :orderCheckId="patientInfo && patientInfo.reportInfo && patientInfo.reportInfo.order_check_id"></imagesRecord>
    </Modal>
  </Row>
</template>
<script>
import imagesRecord from '../../components/imagesRecord'
import { reportPass, rejectReport, giveUpReport } from '../../api/reportAudit'
import { Col, Row, Card, Button, Tree, Modal, Table, Input, Icon } from 'ant-design-vue'
import ReportTemplate from '../../components/ReportTemplate'
import ReportTempModal from './reportTempModal'
import { getParamFromRoute, switchTimeFormat, toast, getSession, openNewWindow } from '../../libs/utils'
import { getDoctorFirstTempList, getDoctorSecondTempList, getDoctorThreeTempList, addTempCategory, editTempCategory, removeTempCategory, getReportPatientInfo, saveReportContent, getDoctorTempInfo, commitReportReview, getMyWritingTask, giveUpWriting, giveUpAllWriting, recall, viewAuditNotPassWhy, editMedicalHistory, changePrinter } from '../../api/report'
import { mapActions, mapState } from 'vuex'
import { WatchImageByWeasisOrOsrix } from '../../libs/mixin'
import Bus from '../../libs/bus'
const saveData = {
  imageRepresentation: '',
  diagnosticResult: ''
}
export default {
  mixins: [WatchImageByWeasisOrOsrix],
  components: {
    Col,
    Row,
    Card,
    Button,
    ReportTemplate,
    Tree,
    Modal,
    Table,
    TextArea: Input.TextArea,
    Input,
    Icon,
    ReportTempModal,
    imagesRecord
  },
  data () {
    return {
      treeData: [], //树形数据
      auditModal: {
        openFlag: false,
        showPass: false,
        showNotPass: false,
        title: '通过审核',
        notPassMsg: '',
        sureBtnLoading: false
      },
      giveUpModal: { // 放弃弹窗
        giveUpBtnLoading: false,
        multiple: false,
        openFlag: false,
        type: '编写',
        tableColumns: [
          {
            title: '报告类型',
            dataIndex: 'cate',
            key: 'cate',
            scopedSlots: { customRender: 'cate' }
          },
          {
            title: 'AI算法',
            dataIndex: 'label',
            key: 'label'
          }
        ],
        tableData: [],
        currentBtnLoading: false,
        allBtnLoading: false
      },
      changeTreeInfo: {
        title: '新增',
        modalFlag: false,
        inputVal: ''
      },
      recall: { // 召回参数
        openFlag: false,
        targetAddress: '编写中',
        sureBtnLoading: false
      },
      editFlag: false,
      editTitleCon: '编辑分类',
      editOrAddInfo: {},
      showReportTemplate: false, // 新增或修改模板弹窗
      routerParams: {}, // 路由参数
      patientInfo: {}, // 患者信息(包含当前报告)
      tempInfo: {}, // 报告模板数据
      notPassWhy: {
        showNotPassWhy: false, // 不通过原因弹框
        notPassList: [],
        columns: [
          {
            title: '审核时间',
            key: 'review_date',
            dataIndex: 'review_date',
            align: 'center'
          },
          {
            title: '审核医生',
            key: 'report_review_doctor_name',
            dataIndex: 'report_review_doctor_name',
            align: 'center'
          },
          {
            title: '不通过原因',
            key: 'deny_comment',
            dataIndex: 'deny_comment',
            align: 'center'
          }
        ]
      },
      role: {}, // 当前用户权限
      submitAuditModal: { // 提交审核弹窗
        openFlag: false,
        errorMsg: '',
        btnLoading: false // 操作确定按钮loading
      },
      templateTitle: '新增模板',
      dieaseHistory: { // 编辑病史
        openFlag: false,
        dieaseContent: ''
      },
      relevantInfomation: { // 相关资料
        openFlag: false,
        fileList: []
      },
      expandedKeys: [],
      routerParamsReportId: '',
      autoSaveTimer: null,
      sureAddClassLoading: false,
      imagesRecordFlag: false,
      passAndPrintLoading: false
    }
  },
  computed: {
    ...mapState({
      ageUnit: state => state.report.ageUnit,
      patientAge: state => state.report.patientAge,
      imageRepresentation: state => state.report.imageRepresentation,
      diagnosticResult: state => state.report.diagnosticResult,
      diseaseList: state => state.report.diseaseList,
      positiveNegative: state => state.report.positiveNegative,
      checkBody: state => state.report.checkBody,
      status: state => state.report.status,
      dieaseRemark: state => state.report.dieaseRemark,
      reportId: state => state.report.reportId,
      writeDoctorId: state => state.report.writeDoctorId,
      checkDoctorId: state => state.report.checkDoctorId,
      overLineFlag: state => state.report.overLineFlag,
      hospitalFlag: state => state.app.hospitalFlag
    }),
    reportTemplateType () {
      if (this.status === 100 || this.status === 20 || this.status === 1) return 'watch'
      return 'edit'
    }
  },
  beforeUpdate () {
    let writing = 10
    let auditing = 30
    let curStatus = this.patientInfo && this.patientInfo.reportInfo && this.patientInfo.reportInfo.status
    let that = this
    Bus.$on('globalSaveReport:modal', async (data) => {
      if ((writing === curStatus) || (auditing === curStatus)) {
        let result = await that.saveReport()
        if (result) that.toNewReportDetail (data)
      }
    })
  },
  async mounted () {
    this.routerParams = getParamFromRoute(this.$route)
    this.role = this.getDoctorRoles()   
    if (this.routerParams.reportId) {
      let report = await getReportPatientInfo({id: this.routerParams.reportId})
      if (report) {
        this.checkViewAuth(report)
        if (report.patientBirthDay) report.patientBirthDay = report.patientBirthDay.substring(0, 10)
        if (report.reportInfo.check_datetime) report.reportInfo.check_datetime = switchTimeFormat(report.reportInfo.check_datetime.substring(0, 10), 5)
        if (report.information && report.information.length > 0) this.relevantInfomation.fileList = report.information
        let patientInfo = {gender: report.gender}
        this.patientInfo = report
        this.setReportData(Object.assign(report.reportInfo, patientInfo))
        if (report.reportInfo.diagnostic_result)  saveData.diagnosticResult = report.reportInfo.diagnostic_result
        if (report.reportInfo.image_representation) saveData.imageRepresentation = report.reportInfo.image_representation
      }
    }
    this.routerParamsReportId = this.routerParams.reportId
    if (this.routerParams.from === 'writing') {
      await this.viewNotPass()
    }
    await this.getDocTempData()
    if (this.status == 10 || this.status == 30) {
      this.autoSaveTimer = setInterval(async () => {
        let flag = false
        if (this.imageRepresentation != saveData.imageRepresentation) {
          saveData.imageRepresentation = this.imageRepresentation
          flag = true
        }
        if (this.diagnosticResult != saveData.diagnosticResult) {
          saveData.diagnosticResult = this.diagnosticResult
          flag = true
        }
        if (flag) return await this.saveReport()
      }, 60000)
    }
  },
  destroyed () {
    if (this.autoSaveTimer) {
      clearInterval(this.autoSaveTimer)
      this.autoSaveTimer = null
    }
    saveData.imageRepresentation = ''
    saveData.diagnosticResult = ''
  },
  methods: {
    ...mapActions([
      'setReportData',
      'setReportStatus',
      'setOverLineFlag'
    ]),
    // 收到上传和解绑影像消息的跳转
    toNewReportDetail (data) {
      let writing = 10
      let curUrl = window.location.origin
      if (data.status === writing) window.location.href = curUrl + `/ris/edit?reportId=${data.id}&from=writing`
      else window.location.href = curUrl + `/ris/edit?reportId=${data.id}`
    },
    // 查看影像传输记录表
    showImagesRecord () {
      this.imagesRecordFlag = true
    },
    // 关闭影像传输记录
    closeImagesRecord () {
      this.imagesRecordFlag = false
    },
    // 判断当前报告是否可以查看
    checkViewAuth (report) {
      if (report.reportInfo.status == 10) {
        if (!this.role.write || report.reportInfo.report_write_doctor_id !== this.role.loginUserId) {
          return this.$router.back()
        }
      } else if (report.reportInfo.status == 30) {
        if (!this.role.review || report.reportInfo.report_review_doctor_id !== this.role.loginUserId) {
          return this.$router.back()
        }
      }
      return true
    },
    // 获取树形模板数据
    async getDocTempData () {
      let data = await getDoctorFirstTempList({ orderCheckReportId: this.routerParams.reportId})
      if (data) {
        let arr = []
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let obj = {}
          obj.title = item.name
          obj.key = item.id
          obj.level = item.level
          obj.creatorId = item.creator_id
          obj.flag = 'addNewTemp'
          obj.scopedSlots = { title: 'custom' }
          arr.push(obj)
        }
        this.treeData = arr
      }
    },
    // 点击编辑分类
    editTreeClass () {
      this.editFlag = !this.editFlag
      if (this.editFlag) {
        this.editTitleCon = '保存分类'
      } else {
        this.editTitleCon = '编辑分类'
      }
    },
    // 编辑模板节点名称
    editCode (item) {
      this.changeTreeInfo.inputVal = item.title
      this.changeTreeInfo.modalFlag = true
      this.changeTreeInfo.title = '编辑'
      this.editOrAddInfo = item
    },
    // 新增模板节点
    addCode () {
      this.changeTreeInfo.inputVal = ''
      this.changeTreeInfo.modalFlag = true
      this.changeTreeInfo.title = '新增一级分类'
      this.editOrAddInfo = {}
    },
    // 确定新增或编辑
    async sureAddClass () {
      if (!this.changeTreeInfo.inputVal) return Modal.error({ title: '请填写分类名称' })
      if (this.sureAddClassLoading) return false
      this.sureAddClassLoading = true
      if (this.changeTreeInfo.title === '新增一级分类' || this.changeTreeInfo.title === '新增二级分类') {
        let params = {
          name: this.changeTreeInfo.inputVal,
          platform: 'applet',
          orderCheckReportId: this.routerParams.reportId
        }
        if (this.editOrAddInfo.level) {
          params.level = this.editOrAddInfo.level + 1
          params.parent = this.editOrAddInfo.key
          params.parentName = this.editOrAddInfo.title
        } else {
          params.level = '1'
        }
        let data = await addTempCategory(params)
        if (data) {
          this.sureAddClassLoading = false
          this.changeTreeInfo.modalFlag = false
          this.getDocTempData()
        }
      } else {
        let params = {
          id: this.editOrAddInfo.key,
          name: this.changeTreeInfo.inputVal
        }
        let result = await editTempCategory(params)
        if (result) {
          this.sureAddClassLoading = false
          this.changeTreeInfo.modalFlag = false
          this.getDocTempData()
        }
      }
    },
    // 删除模板节点
    async removeCode (item) {
      if (item.creatorId === 1) return toast({msg: '该模板为公共模板，禁止删除', title: '提示', type: 'warning'})
      Modal.confirm({
        title: '是否删除该分类',
        content: '确认删除后，将同时删除该分类下的报告模板',
        onOk: async () => {
          let data = await removeTempCategory({ id: item.key })
          if (data) {
            this.getDocTempData()
          }
        }
      })
    },
    // 点击查看模板
    async choiceTreeCode (key, e) {
      if (e.node._props.dataRef.type === 'tempFlag') {
        let data = await getDoctorTempInfo({ id: e.node._props.dataRef.key})
        if (data) {
          this.tempInfo = data
          this.showReportTemplate = true
        }
        this.templateTitle = '应用模板'
      } else {
        this.templateTitle = '新增模板'
      }
      if (e.node._props.dataRef.type === 'second') {
        let result = await getDoctorThreeTempList({ orderCheckReportId: this.routerParams.reportId, subCategoryId: e.node._props.dataRef.key})
        if (result) {
          let tempArr = []
          for (let y = 0; y < result.length; y++) {
            let tempObj = {}
            tempObj.title = result[y].report_name
            tempObj.key = result[y].id
            tempObj.type = 'tempFlag'
            tempArr.push(tempObj)
          }
          e.node._props.dataRef.children = tempArr
          this.treeData = [...this.treeData]
          for (let i = 0; i < this.expandedKeys.length; i++) {
            if (this.expandedKeys[i] === e.node._props.dataRef.key) {
              return this.expandedKeys.splice(i, 1)
            }
          }
          if (this.expandedKeys.length !== 0) {
            this.expandedKeys = [e.node._props.dataRef.key].concat(this.expandedKeys)
          } else {
            this.expandedKeys = [e.node._props.dataRef.key]
          }
        }
      } else {
        let result = await getDoctorSecondTempList({ orderCheckReportId: this.routerParams.reportId, parentId: e.node._props.dataRef.key})
        if (result) {
          let childArr = []
          for (let j = 0; j < result.length; j++) {
            let childObj = {}
            childObj.title = result[j].name
            childObj.key = result[j].id
            childObj.creatorId = result[j].creator_id
            childObj.scopedSlots = { title: 'custom' }
            childObj.parentId = result[j].parent
            childObj.parentName = result[j].parent_name
            childObj.type = 'second'
            childObj.level = result[j].level
            childArr.push(childObj)
          }
          e.node._props.dataRef.children = childArr
          this.treeData = [...this.treeData]
          for (let i = 0; i < this.expandedKeys.length; i++) {
            if (this.expandedKeys[i] === e.node._props.dataRef.key) {
              return this.expandedKeys.splice(i, 1)
            }
          }
          if (this.expandedKeys.length !== 0) {
            this.expandedKeys = [e.node._props.dataRef.key].concat(this.expandedKeys)
          } else {
            this.expandedKeys = [e.node._props.dataRef.key]
          }
        }
      }
    },
    // 点击新增模板
    addNewMould (item) {
      if (item.flag === 'addNewTemp') {
        this.changeTreeInfo.inputVal = ''
        this.changeTreeInfo.modalFlag = true
        this.changeTreeInfo.title = '新增二级分类'
        this.editOrAddInfo = item
      } else {
        item.flag = 'add'
        this.tempInfo = {}
        this.templateTitle = '新增模板'
        Object.assign(this.tempInfo, item)
        this.showReportTemplate = true
      }
    },
    // 存为模板
    saveTemplate (val) {
      this.tempInfo = {
        image_representation: val.imageShow,
        diagnostic_result: val.imageDiagnose,
        flag: 'save',
        diseaseData: val.diseaData,
        templateName: val.templateName
      }
      this.templateTitle = '存为模板'
      this.showReportTemplate = true
    },
    handleCancel () {
      this.showReportTemplate = false
    },
    async deleteTemplate () {
      this.showReportTemplate = false
      await this.getDocTempData()
    },
    // 获取保存和审核的参数
    getSaveOrAuditParams (type) {
      let params = {id: this.reportId}
      if (this.imageRepresentation) params.imageRepresentation = this.imageRepresentation
      if (this.diagnosticResult) params.diagnosticResult = this.diagnosticResult
      if (this.checkBody) params.checkItemName = this.checkBody
      if (this.positiveNegative.toString() === 'true' || this.positiveNegative.toString() === 'false') params.positiveNegative = this.positiveNegative
      if (this.diseaseList.length > 0) {
        let list = []
        this.diseaseList.forEach(item => {
          list.push({code: item.originKey, name: item.label, id: item.id})
        })
        params.diseaseList = JSON.stringify(list)
      }
      if (this.dieaseRemark) params.diseaseComment = this.dieaseRemark
      if (type === 'save') return params
      if (!params.checkItemName) {
        toast({msg: '请输入检查部位'})
      } else if (!params.imageRepresentation) {
        toast({msg: '请填写影像表现'})
      } else if (!params.diagnosticResult) {
        toast({msg: '请填写影像诊断'})
      } else if (params.positiveNegative.toString() === 'true') {
        if (!params.diseaseList) {
          toast({msg: '请选择病种标签'})
        } else {
          this.reportLogicCheck()
          return params
        }
      } else {
        this.reportLogicCheck()
        return params
      }
    },
    // 保存
    async saveReport () {
      if (this.overLineFlag) return toast({msg: '您已超出最大打印报告行数”12行“，请自行调整报告内容'}) // 编写内容太多，超过打印行数
      let params = this.getSaveOrAuditParams('save')
      let data = await saveReportContent(params)
      if (data) {
        toast({msg: '您已成功保存当前报告', type: 'success', title: '成功提示'})
        return true
      }
    },
    // 返回
    async goBack () {
      if (this.status === 10) {
        await this.saveReport()
      }
      this.$router.back()
    },
    // 提交审核
    async submitAudit (type) {
      let params = this.getSaveOrAuditParams('audit')
      if (params && params.imageRepresentation) this.submitAuditModal.openFlag = true
      if (type === 'action') {
        this.submitAuditModal.btnLoading = true
        let data = await commitReportReview(params)
        if (data) {
          toast({msg: '提交审核成功', title: '成功提示', type: 'success'})
          this.setReportStatus(20)
          this.submitAuditModal.btnLoading = true
          return this.$router.back()
        }
        this.submitAuditModal.btnLoading = true
      }
    },
    // 放弃
    async giveUpReports () {
      let params = { id: this.patientInfo.reportInfo.id }
      if (this.patientInfo.reportInfo.status === 30) {
        this.giveUpModal.type = '审核'
        params.status = 'IN_AUDIT'
      }
      if (this.patientInfo.reportInfo.status === 10) {
        this.giveUpModal.type = '编写'
        params.status = 'WRITING'
      }
      this.giveUpModal.giveUpBtnLoading = true
      let data = await getMyWritingTask(params)
      if (data && data.length > 1) {
        this.giveUpModal.tableData = data
        this.giveUpModal.multiple = true
      }
      this.giveUpModal.openFlag = true
      this.giveUpModal.giveUpBtnLoading = false
    },
    // 审核通过
    async pass () {
      let report = await getReportPatientInfo({ id: (this.patientInfo.reportInfo && this.patientInfo.reportInfo.id) || this.routerParams.reportId })
      if (report && report.reportInfo && !report.reportInfo.matched_film_no) {
        return Modal.warning({
          title: '提示',
          content: (h) => 
          (
            <div>
              <p style="display: none">{h}</p>
              <p>影像已被解绑，暂不支持完成该报告</p>
              <p>解绑技师：{report.technicianName}</p>
            </div>
          ),
          okText: '返回',
          okType: 'default'
        })
      }
      let saveParams = this.getSaveOrAuditParams('audit')
      if (!saveParams || !saveParams.id) return false
      let saveData = await saveReportContent(saveParams)
      if (!saveData) {
        toast({msg: '保存报告失败'})
        return false
      }
      this.auditModal.openFlag = true
      this.auditModal.showPass = true
      this.auditModal.showNotPass = false
      this.auditModal.title = '审核通过'
      return true
    },
    // 审核不通过
    notPass () {
      this.auditModal.openFlag = true
      this.auditModal.showPass = false
      this.auditModal.showNotPass = true
      this.auditModal.title = '不通过审核'
    },
    // 确定审核通过和不通过
    async sureAudit () {
      this.auditModal.sureBtnLoading = true
      this.auditModal.showPass ? await this.surePassAudit() : await this.sureNotPassAudit()
      this.auditModal.sureBtnLoading = false
    },
    // 放弃全部
    async giveUpAll () {
      // 审核放弃
      this.giveUpModal.allBtnLoading = true
      if (this.patientInfo.reportInfo.status === 20 || this.patientInfo.reportInfo.status === 30) {
        let reportIdList = []
        this.giveUpModal.tableData.forEach(val => {
          reportIdList.push(val.id)
        })
        await this.sureGiveUpAuditReport(reportIdList)
      }
      // 编写放弃
      if (this.patientInfo.reportInfo.status === 10 || this.patientInfo.reportInfo.status === 1) {
        if (await giveUpAllWriting({id: this.patientInfo.reportInfo.id, status: 'WRITING'})) toast({msg: '放弃全部报告成功', title: '成功提示', type: 'success'})
        this.giveUpModal.openFlag = false
      }
      this.giveUpModal.allBtnLoading = false
    },
    // 放弃当前报告
    async giveUpCurrent () {
      this.giveUpModal.currentBtnLoading = true
      // 审核放弃
      if (this.patientInfo.reportInfo.status === 20 || this.patientInfo.reportInfo.status === 30) {
        await this.sureGiveUpAuditReport([this.patientInfo.reportInfo.id])
      }
      // 编写放弃
      if (this.patientInfo.reportInfo.status === 10 || this.patientInfo.reportInfo.status === 1) {
        if (await giveUpWriting({id: this.patientInfo.reportInfo.id, status: 'WRITING'})) {
          toast({msg: '放弃当前报告成功', title: '成功提示', type: 'success'})
          this.$router.back()
        } 
        this.giveUpModal.openFlag = false
      }
      this.giveUpModal.currentBtnLoading = false
    },
    // 取消放弃
    cancelGiveUp () {
      this.giveUpModal.openFlag = false
    },
    // 确定通过审核
    async surePassAudit () {
      let params = {
        reportId: this.patientInfo.reportInfo.id
      }
      let data = await reportPass(params)
      if (data) {
        toast({ title: '提示', msg: '审核报告通过！', type: 'success' })
        this.auditModal.openFlag = false
        this.$router.back()
      }
    },
    // 确定不通过审核
    async sureNotPassAudit () {
      let params = {
        reportId: this.patientInfo.reportInfo.id
      }
      if (this.auditModal.notPassMsg) params.denyComment = this.auditModal.notPassMsg
      let data = await rejectReport(params)
      if (data) {
        toast({ title: '提示', msg: '审核报告驳回成功', type: 'success' })
        this.auditModal.openFlag = false
        this.$router.replace({ path: '/ris/editReportList', query: { curKey: 3 } })
      }
    },
    // 确定放弃审核报告
    async sureGiveUpAuditReport (idList) {
      let params = idList.join(',')
      let data = await giveUpReport({ reportIdList: params })
      if (data) {
        toast({ title: '提示', msg: '审核报告放弃成功！', type: 'success' })
        this.giveUpModal.openFlag = false
        this.$router.back()
      }
    },
    // 查看报告修改痕迹
    watchReportTrace () {
      return openNewWindow(`/ris/mark?reportId=${this.routerParams.reportId}`)
    },
    // 历史检查页面
    watchCheckHistoy () {
      return openNewWindow(`/ris/reportHistory?reportId=${this.routerParams.reportId}`)
    },
    // 查看不通过原因
    async viewNotPass (val) {
      let data = await viewAuditNotPassWhy({ id: this.patientInfo.reportInfo.id })
      if (val) {
        if (data && data.length > 0) {
          this.notPassWhy.notPassList = data
        }
        this.notPassWhy.showNotPassWhy = true
      } else {
        if (data && data.length > 0) {
          this.notPassWhy.notPassList = data
          this.notPassWhy.showNotPassWhy = true
        }
      }
    },
    // 关闭查看不通过原因弹框
    cancelNotPassWhy () {
      this.notPassWhy.showNotPassWhy = false
    },
    // 召回报告
    recallReport () {
      if (this.status == 20 && (this.role.loginUserId == this.writeDoctorId || this.role.superDoctor)) {
        this.recall.targetAddress = '编写中'
        return this.recall.openFlag = true
      } else if (this.status === 100) {
        if (this.role.superDoctor) {
          if (this.role.loginUserId == this.checkDoctorId) {
            this.recall.targetAddress = '审核中'
          } else if (this.role.loginUserId == this.writeDoctorId) {
            this.recall.targetAddress = '编写中'
          } else {
            this.recall.targetAddress = '审核中'
          }
        } else if (this.role.review && this.role.loginUserId == this.checkDoctorId) {
          this.recall.targetAddress = '审核中'
        } else if (this.role.write && this.role.loginUserId == this.writeDoctorId) {
          this.recall.targetAddress = '编写中'
        }
        return this.recall.openFlag = true
      }
      return toast({msg: '您没有召回此报告的权利', type: 'error'})
    },
    // 召回操作
    async recallAction () {
      let params = {id: this.routerParams.reportId}
      if (this.recall.targetAddress === '编写中') params.targetAddress = 'reportWrite'
      else params.targetAddress = 'reportReview'
      this.recall.sureBtnLoading = true
      let  data = await recall(params)
      if (data) toast({msg: '召回成功', title: '成功提示', type: 'success'})
      this.recall.openFlag = false
      this.recall.sureBtnLoading = false
      this.$router.back()
    },
    recallCancel () {
      this.recall.openFlag = false
    },
    auditCancel () {
      this.submitAuditModal.openFlag = false
    },
    // 当前医生角色
    getDoctorRoles () {
      let auth = { write: false, review: false, superDoctor: false }
      let role = getSession('userAuth', 'object') || null
      let userInfo = getSession('risUserInfo', 'object')
      if (!role || !role.roles || role.roles.length < 1) return auth
      auth.loginUserId = userInfo.id
      for (let i = 0; i < role.roles.length; i++) {
        let item = role.roles[i]
        if (item.rcode === 'ROLE_ROOT') {
          auth.write = true
          auth.review = true
          auth.superDoctor = true
          break
        }
        if (item.rcode === 'ROLE_SENIOR_DOCTOR') auth.superDoctor = true
        if (item.rcode === 'ROLE_AUDIT_REPORT') auth.review = true
        if (item.rcode === 'ROLE_WRITE_REPORT') auth.write = true
      }
      return auth
    },
    // 报告逻辑检查
    reportLogicCheck () {
      this.submitAuditModal.errorMsg = ''
      if (this.checkBody.indexOf('左')!== -1) {
        if (this.imageRepresentation.indexOf('右')!== -1 || this.diagnosticResult.indexOf('右')!== -1) {
          this.submitAuditModal.errorMsg = `左右不一致，如：检查部位名称中包含“左”字样，报告内容中出现“右”字样`
        }
      } else if (this.checkBody.indexOf('右')!== -1) {
        if (this.imageRepresentation.indexOf('左')!== -1 || this.diagnosticResult.indexOf('左')!== -1) {
          this.submitAuditModal.errorMsg = `左右不一致，如：检查部位名称中包含“左”字样，报告内容中出现“右”字样`
        }
      } 
      if (this.patientInfo.gender === '男') {
        if (this.imageRepresentation.indexOf('子宫')!== -1 || this.diagnosticResult.indexOf('子宫')!== -1) {
          this.submitAuditModal.errorMsg = '性别特征不一致，如：男性患者的报告内容中出现“子宫”字样，女性患者的报告内容中出现“前列腺”字样'
        }
      } else if (this.patientInfo.gender === '女') {
        if (this.imageRepresentation.indexOf('前列腺')!== -1 || this.diagnosticResult.indexOf('前列腺')!== -1) {
          this.submitAuditModal.errorMsg = '性别特征不一致，如：男性患者的报告内容中出现“子宫”字样，女性患者的报告内容中出现“前列腺”字样'
        }
      }
    },
    // 编辑病史关闭
    closeDieaseHistory () {
      this.dieaseHistory.openFlag = false
    },
    openDieaseModal () {
      if (this.patientInfo.medicalHistory) this.dieaseHistory.dieaseContent = this.patientInfo.medicalHistory
      this.dieaseHistory.openFlag = true
    },
    // 保存病史
    async saveDieaseHistoy () {
      if (!this.dieaseHistory.dieaseContent) return toast({msg: '请填写病史'})
      let params = {
        orderCheckId: this.patientInfo.reportInfo.order_check_id,
        medicalHistory: this.dieaseHistory.dieaseContent
      }
      let data = await editMedicalHistory(params)
      if (data) {
        this.patientInfo.medicalHistory = this.dieaseHistory.dieaseContent
        this.dieaseHistory.openFlag = false
        toast({msg: '保存病史成功', title: '提示', type: 'success'})
      }
    },
    printReport () {
      changePrinter({reportId: this.reportId})
      return this.$router.push({path: '/ris/printReport', query: { reportId: this.routerParams.reportId }})
    },
    seeMessage() {
      this.relevantInfomation.openFlag = true
    },
    closeRelevantModal () {
      this.relevantInfomation.openFlag = false
    },
    async passAndPrintReport() {
      if (this.passAndPrintLoading) return false
      this.passAndPrintLoading = true
      let report = await getReportPatientInfo({ id: (this.patientInfo.reportInfo && this.patientInfo.reportInfo.id) || this.routerParams.reportId })
      if (report && report.reportInfo && !report.reportInfo.matched_film_no) {
        this.passAndPrintLoading = false
        return Modal.warning({
          title: '提示',
          content: (h) => 
          (
            <div>
              <p style="display: none">{h}</p>
              <p>影像已被解绑，暂不支持完成该报告</p>
              <p>解绑技师：{report.technicianName}</p>
            </div>
          ),
          okText: '返回',
          okType: 'default'
        })
      }
      let saveParams = this.getSaveOrAuditParams('audit')
      if (!saveParams || !saveParams.id) {
        this.passAndPrintLoading = false
        return false
      }
      let saveData = await saveReportContent(saveParams)
      if (!saveData) {
        this.passAndPrintLoading = false
        return toast({msg: '保存报告失败'})
      }
      let params = {
        reportId: this.patientInfo.reportInfo.id
      }
      let data = await reportPass(params)
      if (data) {
        await this.printReport()
      } else {
        toast({msg: '报告审核失败'})
      }
      this.passAndPrintLoading = false
    }
  }
}
</script>
<style lang="less">
@import '../../style/index.less';
.editReportPage{
  height: 100%;
  .pageLeft, .pageRight, .pageCenter{
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .pageLeft, .pageRight{
    background-color: #fff;
    border: 1px solid @divideLineColor;
  }
  // 页面左边
  .pageLeft{
    .ant-card{
      margin-right: -12px;
      .ant-card-body{
        padding: 0;
      }
    }
    .imageCate{
      margin-right: 10px;
    }
    .otherAction{
      margin-top:16px;
      border-top: 1px solid @divideLineColor;
      .leftCell{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid @divideLineColor;
        padding: 10px 24px 5px 24px;
        .cellAction{
          justify-self: flex-end;
        }
      }
      .scanning{
        display: flex;
        justify-content: flex-start;
        padding: 10px 24px 5px 24px;
        border-bottom: 1px solid @divideLineColor;
        position: relative;
        span{
          position: absolute;
          right: 24px;
        }
      }
    }
    // 患者信息
    .patientInfo{
      padding: 16px 24px 0 24px;
      .infoTitle{
        display: flex;
        justify-content: space-between;
        .editHistory{
          justify-self: flex-end;
        }
      }
    }
    // 部位名称
    .bodyNameAndAlias{
      padding: 16px 24px 0 24px;
      border-top: 1px solid @divideLineColor;
    }
    // 相关资料
    .relevantInformation{
      border-top:1px solid @divideLineColor;
      padding: 10px 24px 0 24px;
      .thumbnail{
        display: flex;
        flex-wrap: wrap;
        .thumbnailImage{
          padding:0 5px 5px 0;
          img{
            width: 70px;
            max-height:70px;
            object-fit: cover;
          }
        }
      }
    }
  }
  // 页面中间
  .pageCenter{
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 !important;
    .operateWrap{
      height: 58px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .giveUp{
        margin-left: 10px;
      }
      .btnGroup{
        justify-self: flex-end;
        button{
          margin-right: 10px;
        }
      }
    }
    .reportWrap{
      padding: 0 40px;
      flex: 1;
      overflow-y: auto;
    }
  }
  // 页面右侧
  .pageRight{
    .templateTitle{
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      height: 58px;
      .operate{
        // justify-self: flex-end;
        h2{
          margin-bottom: 0!important;
        }
        a{
          margin-right: 10px;
        }
      }
    }
    .contextWrap{
      .editTreeIcon{
        padding-left: 10px;
      }
    }
  }
}
// 编辑病史
.editDieaseHistory{
  .mainContent{
    .contentWrap{
      .title{
        float:left;
      }
      overflow: hidden;
      span{
        float: right;
      }
    }
  }
}
.watchSlideRelevantInfo();
</style>